export default __webpack_public_path__ + "static/media/waveRed.e1983311.svg";